import React, { useEffect, useState } from "react";
import styles from "./CreateParameterPopup.module.css";
import HeaderCard from "../HeaderCard/HeaderCard";
import Button from "../Button/Button";
import { useTranslation } from "react-i18next";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import { ReactComponent as CharacterParamIcon } from "../../assets/CharacterParamIcon.svg";
import { ReactComponent as TextBoxParamIcon } from "../../assets/TextBoxParamIcon.svg";
import { ReactComponent as UnitMeasureParamIcon } from "../../assets/UnitMeasureParamIcon.svg";
import { ReactComponent as DateParamIcon } from "../../assets/DateParamIcon.svg";
import { ReactComponent as LocationParamIcon } from "../../assets/LocationParamIcon.svg";
import NavigationPopups from "../NavigationPopups/NavigationPopups";
import Textbox from "./types/Textbox";
import NumberComponent from "./types/NumberComponent";
import UnitOfMeasurement from "./types/UnitOfMeasurement";
import Amount from "./types/Amount";
import { ReactComponent as BlackCircleChecked } from "../../assets/blackCircleChecked.svg";
import Discount from "./types/Discount";
import Percentage from "./types/Percentage";
import DateComponent from "./types/Date";
import DateRanges from "./types/DateRanges";
import Location from "./types/Location";
import FilesMedia from "./types/FilesMedia";
import List from "./types/List";
import Category from "./types/Category";
import ColorList from "./types/ColorList";
import Tag from "./types/Tag";
import NewTag from "../NewTag/NewTag";
import Status from "./types/Status";
import Checklist from "./types/Checklist";
import Email from "./types/Email";
import Phone from "./types/Phone";
import Contact from "./types/Contact";
import Asset from "./types/Asset";
import Url from "./types/Url";
import Chronometer from "./types/Chronometer";
import VoiceRecorder from "./types/VoiceRecorder";
import LanguageType from "./types/LanguageType";
import Assessment from "./types/Assessment";
import Formula from "./types/Formula";



const CreateParameterPopup = ({ 
  setState, 
  setShowCreateParameter,
  setLocationState,
  setTypeLocation,
  locationParameter,
  saveParameter, 
  tableId
}) => {
  const [t] = useTranslation("Contacts");

  const [editingInput,setEditingInput] = useState(false)
  const [showSelectCurrencyPopup,setShowSelectCurrencyPopup] = useState(false)
  const [parameterType, setParameterType] = useState("textBox");
  const [showAddTags,setShowAddTags] = useState(false)
  const [selectedTags, setSelectedTags] = useState([]);
  const [tags, setTags] = useState([]);
  const [parameterData, setParameterData] = useState({
    name: "",
    type: "input",
    value: "",
    value2: "",
  });

  const handleChange = (eOrObj) => {
    if (eOrObj?.target) {
      const { name, value } = eOrObj.target;
      setParameterData((prev) => ({ ...prev, [name]: value }));
    } 
    else if (eOrObj?.name && eOrObj?.newValue !== undefined) {
      const { name, newValue } = eOrObj;
      setParameterData((prev) => ({ ...prev, [name]: newValue }));
    }
  };
  

  const handleAddParameter = () => {
    if (!parameterData || typeof parameterData !== 'object') {
      console.error("parameterData no es un objeto válido:", parameterData);
      return;
    }
  
    const newParam = {
      ...parameterData,delete: false, noDelete: false,type: parameterType, // sobrescribe o agrega 'type'
      id: Date.now().toString(36) +  Math.random().toString(36), // sobrescribe o agrega 'id'
    };

    setState((prev) => ({
      ...prev,
      parameters: [...(prev.parameters || []), newParam],
    }));
  
    setShowCreateParameter(false);
  
    setParameterData({
      name: "",
      type: parameterType,
      value: "",
      value2: "",
    });

    saveParameter(newParam, tableId);
  };


  
  

  const currenciesOptions = [
    { name: "United States Dollar", code: "USD", symbol: "US$" },
    { name: "Euro", code: "EUR", symbol: "€" },
    { name: "British Pound", code: "GBP", symbol: "£" },
    { name: "Australian Dollar", code: "AUD", symbol: "A$" },
    { name: "Canadian Dollar", code: "CAD", symbol: "CA$" },
    { name: "Israeli Shekel", code: "ILS", symbol: "₪" },
    { name: "Brazilian Real", code: "BRL", symbol: "R$" },
    { name: "Hong Kong Dollar", code: "HKD", symbol: "HK$" },
    { name: "Swedish Krona", code: "SEK", symbol: "SEK" },
    { name: "New Zealand Dollar", code: "NZD", symbol: "NZ$" },
    { name: "Singapore Dollar", code: "SGD", symbol: "SGD" },
    { name: "Swiss Franc", code: "CHF", symbol: "CHF" },
    { name: "South African Rand", code: "ZAR", symbol: "ZAR" },
    { name: "Chinese Renminbi Yuan", code: "CNY", symbol: "CN¥" },
    { name: "Indian Rupee", code: "INR", symbol: "₹" },
    { name: "Malaysian Ringgit", code: "MYR", symbol: "MYR" },
    { name: "Mexican Peso", code: "MXN", symbol: "MX$" },
    { name: "Pakistani Rupee", code: "PKR", symbol: "PKR" },
    { name: "Philippine Peso", code: "PHP", symbol: "₱" },
    { name: "New Taiwan Dollar", code: "TWD", symbol: "NT$" },
    { name: "Thai Baht", code: "THB", symbol: "THB" },
    { name: "Turkish New Lira", code: "TRY", symbol: "TRY" },
    { name: "United Arab Emirates Dirham", code: "AED", symbol: "AED" },
  ];

  
  useEffect(() => {
    setParameterData((prev) => ({
      ...prev,
      selectedtags: selectedTags,
      tags: tags,
    }));
  }, [selectedTags, tags]);

  const renderParameterInput = () => {
    switch (parameterType) {
      case "textBox":
        return (
          <Textbox parameterData={parameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput}/>
       
        );
      case "number":
        return (
          <NumberComponent parameterData={parameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput}/>
    
        );
      case "unitOfMeasurement":
        return (
          <UnitOfMeasurement parameterData={parameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput}/>
        );
        case "amount":
          return (
          <Amount parameterData={parameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} showSelectCurrencyPopup={showSelectCurrencyPopup} setShowSelectCurrencyPopup={setShowSelectCurrencyPopup}/>
          );
        case "discount":
          return (
          <Discount parameterData={parameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} />
          );
        case "percentage":
          return (
          <Percentage parameterData={parameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} />
          );
      case "date":
        return (
          <DateComponent parameterData={parameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} />
        );
      case "dateRanges":
        return (
          <DateRanges parameterData={parameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} />
        );
      case "location":
        return (
          <Location parameterData={parameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} setTypeLocation={setTypeLocation} setLocationState={setLocationState} locationParameter={locationParameter}/>
        );
      case "filesMedia":
        return (
          <FilesMedia parameterData={parameterData} setParameterData={setParameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} setTypeLocation={setTypeLocation} setLocationState={setLocationState} locationParameter={locationParameter}/>
        );
      case "List":
        return (
          <List parameterData={parameterData} setParameterData={setParameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} setTypeLocation={setTypeLocation} setLocationState={setLocationState} locationParameter={locationParameter}/>
        );
      case "category":
        return (
          <Category parameterData={parameterData} setParameterData={setParameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} setTypeLocation={setTypeLocation} setLocationState={setLocationState} locationParameter={locationParameter}/>
        );
      case "colorList":
        return (
          <ColorList parameterData={parameterData} setParameterData={setParameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} setTypeLocation={setTypeLocation} setLocationState={setLocationState} locationParameter={locationParameter}/>
        );
      case "tag":
        return (
          <Tag parameterData={parameterData} setParameterData={setParameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} setTypeLocation={setTypeLocation} setLocationState={setLocationState} locationParameter={locationParameter} setShowAddTags={setShowAddTags}/>
        );
      case "status":
        return (
          <Status parameterData={parameterData} setParameterData={setParameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} setTypeLocation={setTypeLocation} setLocationState={setLocationState} locationParameter={locationParameter} setShowAddTags={setShowAddTags}/>
        );
      case "checklist":
        return (
          <Checklist parameterData={parameterData} setParameterData={setParameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} setTypeLocation={setTypeLocation} setLocationState={setLocationState} locationParameter={locationParameter} setShowAddTags={setShowAddTags}/>
        );
      case "email":
        return (
          <Email parameterData={parameterData} setParameterData={setParameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} setTypeLocation={setTypeLocation} setLocationState={setLocationState} locationParameter={locationParameter} setShowAddTags={setShowAddTags}/>
        );
      case "phone":
        return (
          <Phone parameterData={parameterData} setParameterData={setParameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} setTypeLocation={setTypeLocation} setLocationState={setLocationState} locationParameter={locationParameter} setShowAddTags={setShowAddTags}/>
        );
      case "contact":
        return (
          <Contact parameterData={parameterData} setParameterData={setParameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} setTypeLocation={setTypeLocation} setLocationState={setLocationState} locationParameter={locationParameter} setShowAddTags={setShowAddTags}/>
        );
      case "asset":
        return (
          <Asset parameterData={parameterData} setParameterData={setParameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} setTypeLocation={setTypeLocation} setLocationState={setLocationState} locationParameter={locationParameter} setShowAddTags={setShowAddTags}/>
        );
      case "url":
        return (
          <Url parameterData={parameterData} setParameterData={setParameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} setTypeLocation={setTypeLocation} setLocationState={setLocationState} locationParameter={locationParameter} setShowAddTags={setShowAddTags}/>
        );
      case "chronometer":
        return (
          <Chronometer parameterData={parameterData} setParameterData={setParameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} setTypeLocation={setTypeLocation} setLocationState={setLocationState} locationParameter={locationParameter} setShowAddTags={setShowAddTags}/>
        );
      case "voiceRecorder":
        return (
          <VoiceRecorder parameterData={parameterData} setParameterData={setParameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} setTypeLocation={setTypeLocation} setLocationState={setLocationState} locationParameter={locationParameter} setShowAddTags={setShowAddTags}/>
        );
      case 'language':
        return (
          <LanguageType parameterData={parameterData} setParameterData={setParameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} setTypeLocation={setTypeLocation} setLocationState={setLocationState} locationParameter={locationParameter} setShowAddTags={setShowAddTags}/>
        );
      case 'assessment':
        return (
          <Assessment parameterData={parameterData} setParameterData={setParameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} setTypeLocation={setTypeLocation} setLocationState={setLocationState} locationParameter={locationParameter} setShowAddTags={setShowAddTags}/>
        );
      case 'formula':
        return (
          <Formula parameterData={parameterData} setParameterData={setParameterData} handleChange={handleChange} editingInput={editingInput} setEditingInput={setEditingInput} setTypeLocation={setTypeLocation} setLocationState={setLocationState} locationParameter={locationParameter} setShowAddTags={setShowAddTags}/>
        );
      default:
        return null;
    }
  };

  return (
  <div>
      <div className={styles.CreateParameterPopup}>
      <div
        className={styles.bg}
        onClick={() => setShowCreateParameter(false)}
      ></div>
      <div className={styles.CreateParameterPopupContent}>
        <HeaderCard
          title={t("newParameterLinkeram")}
          setState={setShowCreateParameter}
        >
          <Button type="white">{t("discard")}</Button>
          <Button action={handleAddParameter}>{t("add")}</Button>
        </HeaderCard>

        <div className={styles.contentContiner}>
     <div className={styles.leftSide}>
     <NavigationPopups
                type={"parameter"}
                text={t("parameter")}
                setParameterType={setParameterType}
              />
     </div>
          <div className={styles.contentParameter}>
            <div>
              <p className={styles.textContent}>{t("parameterTitle")}</p>
              <input
                type="text"
                name="name"
                value={parameterData.title}
                onChange={handleChange}
                placeholder={t("parameterTitle")}
              />
            </div>
            <div className={styles.categoryParameter}>
            <p className={styles.textContent}>{t("parameterTitle")}</p>
                <div className={styles.rightSideCategoryParameter}>
               <div className={styles.row}>
               <CustomDropdown
              editable={true}
              editing={true}
              options={[
                t("length"),
                t("weight"),
                t("volumen"),
                t("time"),
                t("speed"),
              ]}
              customStyles={styles.noPadding}
              selectedOption={parameterData?.physicalQuantities}
              setSelectedOption={(option) =>
                handleChange({ name: "categoryParameter", newValue: option })
              }
              father={'automate'}
            />
            <Button type="white" headerStyle={{borderRadius:"999px"}}>{t('newCategory')}</Button>
               </div>
               <p>{t('parameterCanBeBlocked')}</p>
                </div>
            </div>

          

            <div>
              {renderParameterInput()}
            </div>
          </div>
        </div>
      </div>

    </div>
      {showSelectCurrencyPopup && (
        <>
          <div
            className={styles.bgCurrency}
            onClick={() => setShowSelectCurrencyPopup(false)}
          ></div>
          <div className={styles.newCurrencyPopup}>
            {currenciesOptions.map((currency, subIndex) => {
              const subOption = `${currency.name} (${currency.code}) - ${currency.symbol}`;
              return (
                <div
                  key={subIndex}
                  className={styles.dropdownOption}
                  onClick={async () => {
                    const newCurrency = currency.code;                    
                    
                    setParameterData((prev) => ({
                      ...prev,
                      code: currency.code,
                      currency: currency.currency,
                    }));
                  
                  
                  }}
                  
                >
                  {subOption}
                  {parameterData.code === currency.code && (
                    <BlackCircleChecked />
                  )}
                </div>
              );
            })}
          </div>
        </>
      )}

{showAddTags && (
        <NewTag
          setShowNewTagModal={setShowAddTags}
          setSelectedTags={setSelectedTags}
          selectedTags={selectedTags}
          setTags={setTags}
          tags={tags}
        />
      )}
  </div>
  );
};

export default CreateParameterPopup;
